import React from "react";
import { FALLBACK_IMG } from "@/data/cafe";

export const SmartImage = ({ src, alt, className, ...props }) => {
  const [errored, setErrored] = React.useState(false);
  return (
    <img
      src={errored ? FALLBACK_IMG : src}
      alt={alt}
      loading="lazy"
      onError={() => setErrored(true)}
      className={className}
      {...props}
    />
  );
};
